module.exports = __webpack_public_path__ + "assets/img/user.d6da5350.png";